import { EnumOrganizationMemberPermissions } from '@/helpers/enums/permissions.enum';

export const financials = {
  cartPage: {
    name: 'Cart Page',
    path: '/cart',
    title: 'cart.myShoppingCart',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      shouldHaveMarketplace: true,
    },
  },

  checkoutPage: {
    name: 'Checkout Page',
    path: '/cart/checkout',
    title: 'cart.checkout',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      shouldHaveMarketplace: true,
    },
  },
  myPurchases: {
    name: 'My Purchases',
    path: '/my-purchases',
    title: 'menu.myPurchases',
    icon: 'mdi-wallet-outline',

    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      shouldHaveMarketplace: true,
    },
  },
  myWallet: {
    name: 'My wallet',
    path: '/my-purchases/my-wallet',
    title: 'wallet.MyWallet',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Cart`,
      requiresAuth: true,
      shouldHaveMarketplace: true,
      shouldHaveWalletEnabled: true,
    },
  },
  paymentHistory: {
    name: 'Payment History',
    title: 'menu.paymentHistory',
    icon: 'mdi-bag-personal-outline',
    path: '/my-purchases/payment-history',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Payment History`,
      requiresAuth: true,
      shouldHaveMarketplace: true,
    },
  },
  singleOrder: {
    name: 'Single Order',
    title: 'menu.singleOrder',
    path: '/my-purchases/payment-history/:orderId',
    pathFn: (orderId: string | number) =>
      `/my-purchases/payment-history/${orderId}`,
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Order's Detail`,
      requiresAuth: true,
      shouldHaveMarketplace: true,
    },
  },
  paymentCompleteRedirect: {
    name: 'Redirect to Dashboard',
    path: '/payment-complete',
    title: 'header.verifyingPayment',
    icon: 'mdi-view-dashboard-outline',
    meta: {
      name: `${import.meta.env.VITE_DEFAULT_TITLE} | Verifying Payment`,
      requiresAuth: true,
      memberPermissions: [EnumOrganizationMemberPermissions.AccessCourses],
      dontUseKey: false,
    },
  },
};
